import React from "react";
import DOMPurify from "dompurify";

const SanitizedHTML = ({ html, className = "", style = {} }) => {
  if (!html) return null;

  const sanitizedHTML = DOMPurify.sanitize(html, {
    ADD_ATTR: ["target"],
  });

  return (
    <div
      className={className}
      style={style}
      dangerouslySetInnerHTML={{
        __html: sanitizedHTML,
      }}
    />
  );
};

export default SanitizedHTML;
